import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Hamburger = ({ className }) => {
    return (
        <svg
            className={className}
            fill='none'
            style={{ width: '48px', height: '48px' }}
            viewBox='0 0 60 60'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M17.5 23.96H42.5V26H17.5V23.96Z'
                fill='currentColor' />
            <path
                d='M17.5 34H42.5V36.04H17.5V34Z'
                fill='currentColor' />
        </svg>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    className: PropTypes.string
};

Hamburger.propTypes = propTypes;

export default Hamburger;
